import RecommendList from 'feature/recommand/RecommendList';
import SearchFilterColumn from 'feature/recommand/SnbFilters';
import styled from 'styled-components';

import FilterRow from 'components/common/FilterRow';
import {
	Background,
	BodyInnerWrapper,
	BodyWrapper,
} from 'styles/styled-components/section';

const Recommend = () => {
	return (
		<Background>
			<FilterRow />
			<BodyRow>
				<SearchFilterColumn />
				<BodyWrapper options={{ scrollbars: { autoHide: 'move', autoHideDelay: 250 } }}>
					<BodyInnerWrapper>
						<RecommendList />
					</BodyInnerWrapper>
				</BodyWrapper>
			</BodyRow>
		</Background>
	);
};

const BodyRow = styled.div`
	width: 100%;
	height: calc(100% - 65px);
	display: flex;
`;

export default Recommend;
